// A side-profile sanglier that gallops with gusto: legs swing, body bobs, ear
// flaps, tongue out, and dust kicks up behind the hooves. Used in the sync bar
// while data is pulled, and for the little run across the top after a sync.
export default function RunningBoar({ className = '', size = 44 }) {
  return (
    <svg viewBox="0 0 92 56" width={size * 1.64} height={size} className={className}
         role="img" aria-label="Running boar">
      {/* dust kicked up behind (stays near the ground) */}
      <g fill="#dcdce0">
        <circle className="boar-dust" style={{ animationDelay: '0s' }} cx="12" cy="49" r="4.5" />
        <circle className="boar-dust" style={{ animationDelay: '-.18s' }} cx="6" cy="47" r="3" />
        <circle className="boar-dust" style={{ animationDelay: '-.32s' }} cx="17" cy="51" r="3.2" />
      </g>
      <g className="boar-body">
        {/* tail */}
        <path d="M14 26 q-8 -4 -6 5 q1 5 6 2" fill="#4f331f" />
        {/* far legs (behind, darker) */}
        <rect className="boar-leg" style={{ animationDelay: '-.11s' }} x="31" y="33" width="6" height="18" rx="3" fill="#4f331f" />
        <rect className="boar-leg" style={{ animationDelay: '-.31s' }} x="58" y="33" width="6" height="18" rx="3" fill="#4f331f" />
        {/* body */}
        <path d="M13 30 q0 -16 18 -17 q12 -1 20 3 q8 3 14 2 q9 2 11 10 q1 7 -5 11 q-11 5 -29 4 q-18 -1 -27 -6 q-3 -3 -2 -11 z" fill="#7a5133" />
        {/* mane bristles */}
        <path d="M20 14 l3 -9 l2.6 8 l3 -9 l2.6 8 l3 -9 l2.6 8 l3 -8 l2.6 8" stroke="#4f331f" strokeWidth="3.4" fill="none" strokeLinecap="round" />
        {/* head + snout */}
        <path d="M61 18 q12 -2 19 6 q4 6 2 13 q-2 5 -10 6 l-3 -2 q-9 0 -13 -9 q-2 -8 5 -22 z" fill="#8a5c39" />
        {/* flappy ear */}
        <g className="boar-ear"><path d="M63 13 q-1 -9 6 -9 q3 3 1 12 z" fill="#6b4227" /></g>
        {/* eye + determined brow */}
        <circle cx="70" cy="22" r="1.7" fill="#241109" />
        <path d="M67.5 18.6 q2.5 -1.4 5 0.2" stroke="#3a2115" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        {/* snout */}
        <ellipse cx="81" cy="34" rx="6" ry="4.7" fill="#b07a5c" />
        <ellipse cx="79.2" cy="34" rx="1.1" ry="1.7" fill="#3a2115" />
        <ellipse cx="82.8" cy="34" rx="1.1" ry="1.7" fill="#3a2115" />
        {/* tongue out - full gallop */}
        <path d="M78 38.5 q-1 4.5 2.2 5.5 q3.2 -1 2.2 -5.5 z" fill="#e26d7a" />
        {/* tusk */}
        <path d="M74 39 q-3 0 -3.6 -4.2 q2.6 1 4.7 3.6 z" fill="#f2ead5" />
        {/* near legs (over the body) */}
        <rect className="boar-leg" style={{ animationDelay: '0s' }} x="26" y="34" width="6.6" height="19" rx="3.3" fill="#6b4227" />
        <rect className="boar-leg" style={{ animationDelay: '-.21s' }} x="53" y="34" width="6.6" height="19" rx="3.3" fill="#6b4227" />
      </g>
    </svg>
  );
}
